import CanvasTranspilerProto from './compilers/CanvasTranspiler'

/*
  Generated HTML must in general follow the same output rules as the ingestion tool
  https://docs.google.com/document/d/1YIwFrWA-yKosAEh2CLP3eBVgjtSC96pAyIr3LclCzOI/edit#
*/

/**
 * Generate the HTML of the given blueprint
 *
 * @param Object blueprint
 */
function exportAsHTML(blueprint, options) {
  if (!blueprint || !blueprint.widgetGroups) {
    return ''
  }

  // Create an instance of the given class, and also hydrate the instance with some data
  let canvasTranspiler = _instantiateAndHydrate(CanvasTranspilerProto, {
    blueprint,
    ..._getRenderSettingsOrDefault(options),
  })

  // Construction of HTML document starts at root
  const templateHTML = canvasTranspiler.render(_createRawElement.bind(canvasTranspiler))

  return templateHTML
}

function _instantiateAndHydrate(proto, props = {}) {
  let instance = Object.create(proto)

  return Object.assign(instance, {
    ...props,
    // Copied the instance methods to make the renderers happy
    // but we don't need them for exporting purpose.
    ...instance.methods,
    // Ignore any auxillery slots since we only care about the final output
    $slots: {
      default: [],
    },
  })
}

function _createRawElement(tag, elementAttrs = {}, childNodes = []) {
  // If the given tag is a component proto, then instantiates it and invokes its own render function
  if (typeof tag.render === 'function') {
    let tagInstance = _instantiateAndHydrate(tag, elementAttrs.props)
    // Widgets are coded as vue functional components - see https://vuejs.org/v2/guide/render-function.html#Functional-Components
    // This implementation is not idiomatic Vue (and there was an uncaught error in Hubert's original code)
    // so for things to bootstrap correctly the render function on the non-Vue construct tagInstance needs both
    // the createElement function as well as context object (elementAttrs)
    return tagInstance.render(_createRawElement.bind(tagInstance), elementAttrs)
  }

  // else this is good ol' HTML DOM element...
  const tagName = tag

  const mainAttrs = elementAttrs.attrs
    ? Object.keys(elementAttrs.attrs)
        .filter(k => !!elementAttrs.attrs[k])
        .map(k => `${k}="${elementAttrs.attrs[k]}"`)
        .join(' ')
    : ''

  // style can be in an array of Objects
  const flattenStyles = Array.isArray(elementAttrs.style)
    ? elementAttrs.style.reduce((acc, item) => {
        // merge all style objects
        return Object.assign(acc, item)
      }, {})
    : elementAttrs.style

  const RHStyles = elementAttrs.RHStyles ? ` ${elementAttrs.RHStyles}` : ''
  const styles = flattenStyles
    ? 'style="' +
      Object.keys(flattenStyles)
        .filter(k => !!flattenStyles[k])
        .map(k => `${k}: ${flattenStyles[k]};`)
        .join(' ') +
      RHStyles +
      '"'
    : ''

  const elementBegin = `<${tagName} ${mainAttrs} ${styles} >`
  const elementEnd = `</${tagName}>`
  // child-nodes would be ignore if innerHTML is explicitly defined under element-attributes
  const innerHTML = elementAttrs.domProps && elementAttrs.domProps.innerHTML

  return elementBegin + (innerHTML ? innerHTML : childNodes.join('')) + elementEnd
}

function _getRenderSettingsOrDefault(options) {
  const defaultSettings = {
    // Determine whether to exclude any elements that appear outside of visible content
    // based on their initial position and dimension
    excludeOutofboundContent: true,
    // Whether to clip the image-widget-boundary to be within ad.
    // This works best with excludOutofBoundContent set to true
    clipImageWidgets: true,
  }

  return Object.assign(defaultSettings, options || {})
}

export default { exportAsHTML }
